var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.$store.state.meetSta)?_c('Header',{key:_vm.$store.state.headerfullname}):_vm._e(),(_vm.$store.state.navMenuMainpage)?_c('MenuMainpage'):_vm._e(),(_vm.$store.state.navMenu)?_c('Menu'):_vm._e(),_c('Content'),(_vm.$store.state.loadFooter)?_c('Fotter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }